<template>
  <BaseModal>
    <template v-slot:modalheader>
      <p class="title is-4">
        {{ $t("faq.title") }}
      </p>
    </template>
    <template v-slot:modalbody>
      <p>
        {{ $t("faq.description") }}
      </p>
    </template>
    <template v-slot:modalfooter>
      <b-button
        outlined
        type="is-primary"
        :aria-label="$t('message.close_btn')"
        @click="$parent.close()"
      >
        <font-awesome-icon :icon="['fas', 'times']" />
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/base-components/BaseModal.vue";
export default {
  name: "FaqModal",
  components: {
    BaseModal
  }
};
</script>

<style></style>
